export const SOURCE_NAME = 'jiraAutomationRecommendationsPanel';
